import React, { useEffect, useState } from "react";
import { Button, Row, Col, Divider, Radio, Form } from "antd";
import { RightSquareOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { getRoleList } from "redux/actions/getRole.action";
import { getApiArrayDetails } from "../../../utils/MyMUtils";

function ExistingStep1(props) {
  const [roleName, setRoleName] = useState();
  const dispatch = useDispatch();
  const getRoleData = useSelector((state) => getApiArrayDetails(state.getRole.data));


  useEffect(() => {
    setRoleName(props?.userRol?.role_id);
    props.selectRole(props?.userRol?.role_id)
  }, [props?.userRol]);


  const onChange = (e) => {
    setRoleName(e?.target?.value);
    props.selectRole(e?.target?.value);
  };


  useEffect(() => {
    dispatch(getRoleList());
  }, []);

  const next = () => {
    props.next();
  };

  return (
    <>
      <div className="steps-content">
        <Divider style={{ fontSize: "22px" }}>Select Role</Divider>
        <Form hideRequiredMark>
          <Row gutter={24} style={{ marginLeft: "0px", marginRight: "0px" }} className="mt-4">
            <Radio.Group  onChange={onChange} style={{ width: "100%", display: "contents" }} value={roleName} >
              {getRoleData &&
                getRoleData.map((role) => {
                  return (
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <div className="outer-radio-role">
                        <Radio  value={role?.role_id} className="d-flex justify-content-start">
                          {role.role_name}
                        </Radio>
                      </div>
                    </Col>
                  );
                })}
            </Radio.Group>
          </Row>
        </Form>
      </div>

      <Row gutter={24} className="mt-2">
        <Col lg={12} md={12} sm={24} xs={24}></Col>
        <Col lg={12} md={12} sm={24} xs={24} className="text-right">
          <Button shape="round" icon={<RightSquareOutlined />} onClick={next}>
            Next
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default ExistingStep1;
